import {
  Card,
  CardContent,
  Typography,
  List,
  ListItem,
  Box,
} from "@mui/material";
import useDarkMode from "./useDarkMode";
import { Helmet } from "react-helmet-async";

const AdminSettings = () => {
  useDarkMode();
  return (
    <>
      <Helmet>
        <title>AKAAL KIDS - Admin Panel | Settings</title>
      </Helmet>
      <Box
        sx={{
          mt: 4,
          display: "flex",
          flexDirection: "column",
          alignItems: "flex-start",
        }}
      >
        <Card sx={{ maxWidth: 500, width: "100%", boxShadow: 3 }}>
          <CardContent>
            <Typography variant="h4" gutterBottom>
              Admin Settings
            </Typography>
            <Typography variant="body1" color="text.secondary" gutterBottom>
              Configure platform and admin settings. Use this section to update
              preferences, security, and other options.
            </Typography>
            <List>
              <ListItem>Change password</ListItem>
              <ListItem>Update contact information</ListItem>
              <ListItem>Manage notification preferences</ListItem>
            </List>
          </CardContent>
        </Card>
      </Box>
    </>
  );
};

export default AdminSettings;
